import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface SearchBoxProps {
  variant?: "navbar" | "hero" | "page";
  defaultValue?: string;
  placeholder?: string;
}

export default function SearchBox({
  variant = "navbar",
  defaultValue = "",
  placeholder = "搜索影片、电视剧、综艺…",
}: SearchBoxProps) {
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const kw = value.trim();
    if (!kw) return;
    navigate(`/search?q=${encodeURIComponent(kw)}`);
  };

  if (variant === "hero") {
    return (
      <form
        onSubmit={handleSubmit}
        className="flex w-full max-w-xl items-center gap-2 rounded-md border border-background-300/60 bg-background-100/80 p-1.5 backdrop-blur"
      >
        <span className="flex h-9 w-9 items-center justify-center text-foreground-500">
          <i className="ri-search-line text-lg"></i>
        </span>
        <input
          type="text"
          name="search"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          className="h-10 flex-1 bg-transparent text-sm text-foreground-950 placeholder:text-foreground-500 focus:outline-none"
        />
        <button
          type="submit"
          className="flex h-10 items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
        >
          <i className="ri-search-2-line text-base"></i>
          搜索
        </button>
      </form>
    );
  }

  if (variant === "page") {
    return (
      <form
        onSubmit={handleSubmit}
        className="flex w-full items-center gap-2 rounded-md border border-background-300/60 bg-background-100 p-1.5"
      >
        <span className="flex h-9 w-9 items-center justify-center text-foreground-500">
          <i className="ri-search-line text-lg"></i>
        </span>
        <input
          type="text"
          name="search"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          className="h-10 flex-1 bg-transparent text-sm text-foreground-950 placeholder:text-foreground-500 focus:outline-none"
        />
        <button
          type="submit"
          className="flex h-10 items-center whitespace-nowrap rounded-md bg-primary-500 px-5 text-sm font-medium text-foreground-950 transition-colors hover:bg-primary-600"
        >
          搜索
        </button>
      </form>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="hidden h-10 items-center gap-1.5 rounded-md border border-background-300/60 bg-background-100 px-2.5 lg:flex"
    >
      <span className="flex h-6 w-6 items-center justify-center text-foreground-500">
        <i className="ri-search-line text-base"></i>
      </span>
      <input
        type="text"
        name="search"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="搜索影视…"
        className="h-full w-40 bg-transparent text-sm text-foreground-950 placeholder:text-foreground-500 focus:outline-none xl:w-52"
      />
    </form>
  );
}